<template>
  <div class="sales-owned">

    <div class="container-header sales-owned__header">
      <searcher @search-input="loadFilteredSales"/>
    </div>

    <template v-if="salesOwned.length">
      <div class="md-layout md-gutter md-size-100 md-alignment-top-left sales-overview__inner">
        <router-link v-for="sale in salesOwned"
                     :key="sale.id"
                     :to="{name: 'sales.sale-details', params: { id: sale.id }}"
                     tag="div"
                     class="md-layout-item sales-overview__card-wrapper md-size-33 md-xlarge-size-25 md-medium-size-50 md-small-size-100"
        >
          <sale-card :sale="sale"/>
        </router-link>
      </div>
    </template>

    <template v-else>
      <not-available-card icon='trending_up' :title="i18n.sale_nothing_found()" :descr="i18n.sale_no_created_sales()"/>
    </template>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { vuexTypes } from '@vuex/types'
  import { i18n } from '@js/i18n'

  import NotAvailableCard from '../common/NotAvailableCard'
  import SaleCard from '../sales/sale_card/Sales.SaleCard'
  import Searcher from '../sales/overview/Sales.Searcher'
  import FormMixin from '@com/mixins/form.mixin'
  import { saleSortTypes, saleStates } from '@const'

  const initialState = saleStates.actual
  const initialSort = saleSortTypes.created

  export default {
    name: 'MySalesIndex',
    components: {
      SaleCard,
      Searcher,
      FormMixin,
      NotAvailableCard
    },
    data: _ => ({
      i18n,
      isLoaded: false,
      filters: {
        openOnly: initialState.openOnly,
        upcoming: initialState.upcoming,
        sortBy: initialSort.num,
        order: initialSort.order,
        baseAsset: ''
      }
    }),
    async created () {
      this.isLoaded = true
      await this.loadFilteredSales()
      // this.loadSales()
    },
    computed: {
      ...mapGetters([
        vuexTypes.salesOwned
      ])
    },
    methods: {
      ...mapActions({
        loadSalesByName: vuexTypes.GET_SALES_BY_NAME
      }),
      loadFilteredSales (filters, type = null) {
        if (filters) {
          this.filters.openOnly = filters.state.openOnly
          this.filters.upcoming = filters.state.upcoming
          this.filters.sortBy = filters.sortBy.num
          this.filters.order = filters.sortBy.order
          this.filters.baseAsset = filters.token
          this.filters.name = filters.name
          this.filters.type = type
        } else {
          this.filters.openOnly = false
          this.filters.upcoming = false
        }
        return this.loadSalesByName(this.filters)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~scss/variables';
  @import '~scss/mixins';

  .sales-owned__header {
    padding: 0 12px;
    background-color: $default-white;
  }

  .container-header {
    @include respond-to(large) {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  .sales-overview__inner {
    width: 100%;
    @include respond-to(medium-tablet) {
      justify-content: center;
    }
  }

  .sales-overview__card-wrapper {
    display: block;
    height: auto;
    max-height: 550px;
    margin-bottom: 1.5rem;
    font-size: initial;
    text-align: initial;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/salesOwned/SalesOwned.Index.vue